module.exports = __webpack_public_path__ + "img/folder-check.d285925f.svg";